import React from "react";

const ServicesSection = () => {
  return (
    <section className="lg:px-40 px-4 lg:py-16 py-16">
      <div className="container mx-auto text-center">
        <h2 className="text-4xl font-bold mb-4">Our Comprehensive Service</h2>
        <p className="text-lg mb-12">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse
          tincidunt sagittis eros. Quisque quis euismod lorem.
        </p>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Service Card 1 */}
          <div className="bg-white p-6 rounded shadow-md text-center">
            <img
              src="https://imgs.search.brave.com/hQbkLQoLwXZfuvZcIWHeoUJXih54oYQUqdqqetWFmvo/rs:fit:860:0:0:0/g:ce/aHR0cHM6Ly93ZWFs/bHNldy5jb20vd3At/Y29udGVudC91cGxv/YWRzL3NpdGVzLzQv/MjAxNS8xMS9CdXR0/b25ob2xlLVNld2lu/Zy1UaXAtMTIwMC14/LTgwMC1XZUFsbFNl/dy1CRVJOSU5BLUJs/b2ctNC5qcGc"
              alt="Service 1"
              className="w-full h-48 object-cover rounded mb-4"
            />
            <h3 className="text-2xl font-bold mb-2">
              Precision Kaaj Button Solutions
            </h3>
            <p className="text-gray-600 mb-4">
              Our specialized 'Kaaj Button' services ensure that your jeans are
              perfectly finished with secure button closures. With advanced
              techniques and experienced craftsmen, we deliver unmatched quality
              and durability.
            </p>
            
          </div>

          {/* Service Card 2 */}
          <div className="bg-white p-6 rounded shadow-md text-center">
            <img
              src="https://imgs.search.brave.com/v-yHLfqbyWYOR0dI07SJEWuxjL33kwWIeQPW5JEXNcM/rs:fit:860:0:0:0/g:ce/aHR0cHM6Ly9pMC53/cC5jb20vd3d3LnRo/ZWxhc3RzdGl0Y2gu/Y29tL3dwLWNvbnRl/bnQvdXBsb2Fkcy9T/ZXdpbmctSmVhbnMt/VG9wc3RpdGNoaW5n/LVR1dG9yaWFsLTEu/anBnP3Jlc2l6ZT02/MDAsNDYwJnNzbD0x"
              alt="Service 2"
              className="w-full h-48 object-cover rounded mb-4"
            />
            <h3 className="text-2xl font-bold mb-2">Expert Denim Stitching</h3>
            <p className="text-gray-600 mb-4">
              From jeans pants to jackets, our expert stitching services bring
              your designs to life. We focus on precision and attention to
              detail, ensuring each piece meets the highest standards of
              craftsmanship
            </p>
            
          </div>

          {/* Service Card 3 */}
          <div className="bg-white p-6 rounded shadow-md text-center">
            <img
              src="https://imgs.search.brave.com/fSkzZhoxO9HXba-39sP_jpvIQneH_0PMyEbOTm8gg8I/rs:fit:860:0:0:0/g:ce/aHR0cHM6Ly9sb3Zl/bHlwYWNrYWdlLmNv/bS93cC1jb250ZW50/L3VwbG9hZHMvMjAx/NC8wNS9sb3ZlbHkt/cGFja2FnZS1tdXN0/YW5nLWRlbmltLTEt/ZTE0MDEyMzcyODQ3/MzEuanBn"
              alt="Service 3"
              className="w-full h-48 object-cover rounded mb-4"
            />
            <h3 className="text-2xl font-bold mb-2">Flawless Finishing</h3>
            <p className="text-gray-600 mb-4">
              Our finishing services include pressing, tagging, and packaging,
              ensuring your products are ready for market. With meticulous
              attention to detail, we prepare your jeans for a polished and
              professional presentation.
            </p>
            
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
